import script from "./MaterialGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialGallery.vue?vue&type=script&setup=true&lang=js"

import "./MaterialGallery.vue?vue&type=style&index=0&id=4278ac0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4278ac0e"]])

export default __exports__